import { gql } from "graphql-request";

const SERVER_GET_CREATE_DOCUMENT_TEMPLATE = gql`
  {
    documentTags {
      id
      name
      fieldName
      group
      category
      relatedColumn
      relatedType
    }

    documentTypes {
      id
      name
      category
    }
  }
`

export default SERVER_GET_CREATE_DOCUMENT_TEMPLATE;
